import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import FlipButton from "../../components/FlipButton/FlipButton";
import ImageMagnifier from "../../components/ImageMagnifier/ImageMagnifier";
import styles from "./ZoomModal.module.css";

const ZoomModal = ({
  modalId = "modelZoomModal",
  front,
  back,
  onClose,
  showFlip = true,
  isBackground = false,
}) => {
  const [flipped, setFlipped] = useState(false);
  const hasBackImage = typeof back === "string" ? back.trim().length > 0 : Boolean(back);
  const canFlip = Boolean(showFlip && hasBackImage);
  const frontFaceClassName = isBackground
    ? styles.front
    : `${styles.front} ${styles.front1}`;

  useEffect(() => {
    if (!canFlip && flipped) {
      setFlipped(false);
    }
  }, [canFlip, flipped]);

  const handleClose = () => {
    if (onClose) onClose();
  };

  return createPortal(
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      aria-labelledby={`${modalId}Label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className={`modal-content position-relative ${styles.modalContent}`}>
          <button
            type="button"
            className={`${styles.closeButton}`}
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            ×
          </button>

          <div className="modal-body d-flex justify-content-center align-items-center p-3 p-md-4">
            <div
              className={
                isBackground
                  ? styles.flipContainer_background
                  : styles.flipContainer
              }
            >
              <div
                className={`${styles.flipcard} ${
                  canFlip && flipped ? styles.flipped : ""
                }`}
              >
                <div className={frontFaceClassName}>
                  {front && (
                    <ImageMagnifier
                      src={front}
                      alt="front"
                      centerOnOpen
                      isFaceActive={!canFlip || !flipped}
                    />
                  )}
                </div>

                {canFlip && (
                  <div className={styles.back}>
                    {back && (
                      <ImageMagnifier
                        src={back}
                        alt="back"
                        centerOnOpen
                        isFaceActive={flipped}
                      />
                    )}
                  </div>
                )}
              </div>

              {canFlip && (
                <div className={styles.flipButtonWrapper}>
                  <FlipButton setIsFlipped={setFlipped} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ZoomModal;
